/*
 * Bootstrap Validation
 * Version 1.0.7
 * Modified from <https://github.com/sagrawal14/bootstrap-angular-validation>.
 **/

'use strict';

angular.module('bootstrap.angular.validation', []);
